import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'web-components';
export const UnlinkButton = ({ onClick, messageId = 'common.unlink', }) => {
    return (React.createElement("div", { style: { marginTop: '8px' } },
        React.createElement(Button, { onClick: onClick, size: Button.SIZE.STANDARD, variant: Button.VARIANT.RED_FILLED },
            React.createElement(FormattedMessage, { id: messageId }))));
};
